import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const RealEstateManagerDetail = () => {
  const [realEstate, setRealEstate] = useState({});
  const [status, setStatus] = useState(1);
  const [editors, setEditors] = useState([]); // List of editors
  const [selectedEditor, setSelectedEditor] = useState(""); // Selected editor
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const getRealEstateById = async () => {
    try {
      const response = await axios.get(`/real-estate/${id}`);
      setRealEstate(response.data);
      setSelectedEditor(response.data.editor || ""); // Set selected editor from fetched data
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1); // Set status from fetched data
    } catch (error) {
      console.error(error);
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  const getEditors = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      const editorUsers = response.data.filter(
        (user) => user.role === "editor"
      );
      setEditors(editorUsers);
    } catch (error) {
      console.error("Error fetching editors:", error);
    }
  };

  useEffect(() => {
    getRealEstateById();
    getEditors();
  }, []);

  const updateRealEstate = async () => {
    try {
      await axios.put(`/real-estate/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/realestate-manager");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        {errorMessage && (
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              class="btn-close shadow-none"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        )}
        <div className="row">
          {/* Left Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Event Name:</strong> {realEstate.order_name}
                </p>
                <p>
                  <strong>Service Type:</strong> {realEstate.serviceId?.service}
                </p>
                <p>
                  <strong>Album Type:</strong> {realEstate.serviceId?.service}
                </p>
              </div>
            </div>{" "}
            <div className="card mb-3">
              <div className="card-header fw-600">Order Details</div>
              <div className="card-body">
                <p>
                  <strong>ADD-ONS - Remove cables and wires :</strong>{" "}
                  {realEstate.remove_cable}
                </p>
                <p>
                  <strong>ADD-ONS - Clean Swimming Pool :</strong>{" "}
                  {realEstate.clean_swimmingpool}
                </p>
                <p>
                  <strong>ADD-ONS - Grass Replacement :</strong>{" "}
                  {realEstate.grass_replacement}
                </p>{" "}
                <p>
                  <strong>ADD-ONS - Add Sky :</strong> {realEstate.add_sky}
                </p>{" "}
                <p>
                  <strong>ADD-ONS - Add TV Image :</strong>{" "}
                  {realEstate.add_tvImage}
                </p>{" "}
                <p>
                  <strong>ADD-ONS - Add Fireplace :</strong>{" "}
                  {realEstate.add_fireplace}
                </p>{" "}
                <p>
                  <strong> Quantity :</strong> {realEstate.quantity}
                </p>{" "}
                <p>
                  <strong> Social Media :</strong> {realEstate.social_media}
                </p>{" "}
                <p>
                  <strong> Link :</strong> {realEstate.drive_link}
                </p>{" "}
                <p>
                  <strong> Upload:</strong> {realEstate.images}
                </p>{" "}
                <p>
                  <strong> Aditional notes :</strong>{" "}
                  {realEstate.additional_notes}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Order Operations</div>
              <div className="card-body">
                <p>
                  <strong>Client ID:</strong> {realEstate.userId?.id}
                </p>
                <p>
                  <strong>Order ID:</strong> {realEstate.id}
                </p>
                <p>
                  <strong>User Feedback:</strong> {realEstate.sampleFeedback}
                </p>
                <p>
                  <strong>Sample Status:</strong>{" "}
                  {realEstate.sampleStatus === "approved" ? (
                    <span className="btn rounded-0 btn-success btn-sm p-2 ms-2">
                      Approved
                    </span>
                  ) : realEstate.sampleStatus === "declined" ? (
                    <span className="btn rounded-0 btn-danger btn-sm p-2 ms-2">
                      Declined
                    </span>
                  ) : (
                    <span className="text-muted ms-2">Not Selected</span>
                  )}
                </p>
                <p>
                  <strong>Order Place Date:</strong>{" "}
                  {new Date(realEstate?.createdAt).toLocaleDateString()}
                </p>
                <div>
                  <label className="form-label">Order Status</label>
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => setStatus(Number(e.target.value))}
                  >
                    <option value={1}>New Order</option>
                    <option value={2}>In Process</option>
                    <option value={3}>On Hold</option>
                    <option value={4}>In QC</option>
                    <option value={5}>Sample Sent</option>
                    <option value={6}>In Revision</option>
                    <option value={7}>Cancelled</option>
                    <option value={8}>Completed</option>
                  </select>{" "}
                </div>
                <div className="mt-3">
                  <label className="form-label">Select Editor</label>
                  <select
                    className="form-select"
                    value={selectedEditor}
                    onChange={(e) => setSelectedEditor(e.target.value)}
                  >
                    <option value="">Select an editor</option>
                    {editors.map((ed) => (
                      <option key={ed._id} value={ed.fname}>
                        {ed.fname}
                      </option>
                    ))}
                  </select>
                </div>

                <label className="form-label mt-3">File Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={fileLocation}
                  onChange={(e) => setFileLocation(e.target.value)}
                />
                <>
                  <label className="form-label mt-3">Message</label>
                  <input
                    type="text"
                    className="form-control"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </>
                <button
                  onClick={updateRealEstate}
                  className="btn text-light bg_maincolor mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RealEstateManagerDetail;
